import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { safeInsert } from '@atlaskit/editor-prosemirror/utils';
import { generateSyncBlockSourceUrl } from '@atlaskit/editor-synced-block-provider';
import { findSyncBlock } from './utils/utils';
export var createSyncedBlock = function createSyncedBlock(tr, syncBlockStore, typeAheadInsert) {
  var syncBlock = tr.doc.type.schema.nodes.syncBlock;
  var syncBlockNode = syncBlockStore.createSyncBlockNode();

  // If the selection is empty, we want to insert the panel on a new line
  if (tr.selection.empty) {
    var node = syncBlock.createAndFill(_objectSpread({}, syncBlockNode.attrs));
    if (!node) {
      return false;
    }
    if (typeAheadInsert) {
      tr = typeAheadInsert(node);
    } else {
      tr = tr.replaceSelectionWith(node).scrollIntoView();
    }
  } else {
    var _safeInsert;
    // TODO: EDITOR-1653 - put selection inside the sync block if possible
    (_safeInsert = safeInsert(syncBlock.createAndFill(syncBlockNode.attrs))(tr)) === null || _safeInsert === void 0 || _safeInsert.scrollIntoView();
  }
  return tr;
};
export var copySyncedBlockReferenceToClipboard = function copySyncedBlockReferenceToClipboard(api) {
  return function (state, dispatch, _view) {
    if (!(api !== null && api !== void 0 && api.floatingToolbar) || !dispatch) {
      return false;
    }
    var syncBlock = state.schema.nodes.syncBlock,
      tr = state.tr;
    var newTr = api.floatingToolbar.commands.copyNode(syncBlock, INPUT_METHOD.FLOATING_TB)({
      tr: tr
    });
    if (!newTr) {
      return false;
    }
    dispatch(newTr);
    return true;
  };
};
export var editSyncedBlockSource = function editSyncedBlockSource(_api) {
  return function (state, _dispatch, _view) {
    var syncBlock = findSyncBlock(state);
    if (!syncBlock) {
      return false;
    }
    var url = generateSyncBlockSourceUrl(syncBlock.node);
    if (!url) {
      return false;
    }
    window.open(url, '_blank');
    return true;
  };
};
export var removeSyncedBlock = function removeSyncedBlock(api) {
  return function (state, dispatch, _view) {
    var _state$selection = state.selection,
      from = _state$selection.$from.pos,
      to = _state$selection.$to.pos,
      tr = state.tr;
    var syncBlock = findSyncBlock(state);
    if (!syncBlock) {
      return false;
    }
    if (!dispatch) {
      return false;
    }
    var newTr = tr.deleteRange(from, to);
    if (!newTr) {
      return false;
    }
    dispatch(newTr);
    api === null || api === void 0 || api.core.actions.focus();
    return true;
  };
};